.iv-sw-button {
  margin-bottom: 2.5rem;
  background: black;
  color: white;
  border: 1px solid transparent;
  outline: none;
  padding: 0.75rem 1.5rem;
  text-transform: uppercase;
  font-weight: 400;
  border-radius: unset;
  font-size: 1rem;
  cursor: pointer;
  transition: all .5s;
  
  &:hover {
    transition: all .5s;
    border-color: black;
    background: white;
    color: black;
  }

}

.table-wrapper {
  max-height: 420px;
  overflow-y: auto;
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
  scrollbar-color: #111 #fff;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 10px;
    background: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background: #111;
    border-radius: 0;
  }

  &::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 0;
  }

  > table {
    width: 100%;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;
    color: #222;
    background: #fff;
    border-radius: 0.5rem;

    th, td {
      text-align: center;
      vertical-align: middle;
      padding: 1.25rem 0.75rem;
      border-bottom: 1px solid #ececec;
      color: #222;
      background: #fafafa;
    }

    th {
      position: sticky;
      top: 0;
      font-weight: 600;
      background: #f5f5f5;
      color: #111;

      > select {
        outline: 0;
        border-radius: 0;
        border: 0;
        position: relative;
        font-size: inherit;
        background-color: transparent;
        padding: .75em 1em;
      }

    }

    tr:last-child td {
      border-bottom: none;
    }

    tbody tr {
      transition: background 0.2s;
      &:hover {
        background: #f0f0f0;
      }
    }

  }
    
} 